import React from 'react';
import ReactDOM from 'react-dom';
import Dashboard from './dashboard.jsx';

const renderApp = () => {
  ReactDOM.render(
    <>
      <Dashboard />
    </>,
    document.getElementById('dashboard-outer')
  );
};

renderApp();
